var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('entity-link',{attrs:{"entityId":_vm.item}}),_vm._v(": "),_c('atoms',{attrs:{"atoms":_vm.properties,"compact":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }